import { useEffect, useRef } from 'react'
import { io, Socket } from 'socket.io-client'
import { config } from '../config'
import { IEvent } from '../types/event.type'

/**
 * Subscribe to socket.io rooms for one or more playbooks.
 * Calls `onEvent` whenever an event is received for any of the subscribed playbooks.
 */
export function usePlaybookSocket(playbookIds: number[], onEvent: (ev: IEvent) => void) {
  // Use a ref for the callback so that changing the callback
  // doesn't tear down and recreate the socket connection.
  const onEventRef = useRef(onEvent)
  onEventRef.current = onEvent

  // Serialize IDs so useEffect can compare by value, not reference.
  const idsKey = playbookIds.join(',')

  useEffect(() => {
    if (playbookIds.length === 0) return

    const socket: Socket = io(config.baseUrl)
    const rooms = playbookIds.map((id) => `playbook${id}`)

    for (const room of rooms) {
      console.debug(`joining room ${room}`)
      socket.emit('joinRoom', room)
    }

    socket.on('events', (ev: IEvent) => {
      onEventRef.current(ev)
    })

    return () => {
      for (const room of rooms) {
        console.log(`leaving room ${room}`)
        socket.emit('leaveRoom', room)
      }
      socket.off('events')
      socket.disconnect()
    }
  }, [idsKey])
}
